import React from "react";
import ReactDOM from "react-dom"
import BaseDialog from "./BaseDialog";
import VariableDataModel from "../../models/VariableDataModel";
import PropertyPanelWidget from "../PropertyPanelWidget";
import Utility from "../../utilities/Utility";

export default class NewLocalVariableDialog extends BaseDialog {
    /**
     * Dialog for adding local variable for module
     * @module NewLocalVariableDialog
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.addHandle = this.handleAdd.bind(this);
        this.tempNode = new VariableDataModel(null, null, {isDialog: true});
        this.tempNode.props.parentModule = props.useModule || window.apm.getCurrentDiagramWidget().props.node.id;
        this.tempNode.isEmbed = true;
       
        this.state = {
            tempVariable: this.tempNode
        }

        this.refeshPropsHandle = this.refeshPropsHandle.bind(this);
    }

    componentDidMount(){
        document.addEventListener("ev-dialog-add", this.addHandle);
        document.addEventListener("ev-dialog-variable-changed", this.refeshPropsHandle);
        Utility.hidePropertyPanel();
        Utility.focusPropertyPanelInput();
    }

    componentWillUnmount(){
        document.removeEventListener("ev-dialog-add", this.addHandle);
        document.removeEventListener("ev-dialog-variable-changed", this.refeshPropsHandle);
    }

    /**
     * 
     */
    handleAdd(){
        const newLocalVariable = this.state.tempVariable;
        const newLocalVarName = newLocalVariable.getConfig("varName")
        const newLocalVarType = newLocalVariable.getConfig("type")
        const newLocalVarParentId = newLocalVariable.props.parentModule
        const newLocalVarConfig = newLocalVariable.props.config

        if (!newLocalVariable.hasError()) {
                // provide createdTime
                newLocalVariable.props.createdTime = window.apm.timestamp;
                
                // add variable to module
                window.apm.setVariable(
                    newLocalVarName,
                    newLocalVarType,
                    null,
                    newLocalVarParentId, 
                    newLocalVarConfig
                );
                
                // handle module inputs
                if(newLocalVarConfig.moduleInput){
                    window.apm.addModuleInput(newLocalVariable, newLocalVarParentId, window.apm.serialized);
                }

                w2popup.close();
                ReactDOM.unmountComponentAtNode($(".new_element_container").get(0));

                // Must use VariableDataModel of the newly created local variable to open property panel
                const getVarFromParent = window.apm.getVariable(newLocalVarName, newLocalVarParentId);
                const proxyVar = new VariableDataModel(getVarFromParent.props, getVarFromParent.id);
                window.apm.postEventToCurrentView({ 
                    target: "request-variable-property-panel",
                    event: { node: proxyVar } 
                });
                window.apm.postEventToCurrentView({
                    target: "request-update-member"
                });
        } 
        else {
            alert(window.l.popup.fix_error);
        }
    }

    // manages state of tempVariable in dialog, passes as context prop to property panel
    refeshPropsHandle(e){
        this.setState({tempVariable: e.detail.variable});

    }

    unregister(){
        document.removeEventListener("ev-dialog-add", this.addHandle);
        document.removeEventListener("ev-dialog-variable-changed", this.refeshPropsHandle);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <div className={"container-fluid element-dialog element-body"}>
                    <div className={"row"}>
                        <div className="col-md-12">
                            
                            {<PropertyPanelWidget 
                                context={this.state.tempVariable} 
                                embed={true} 
                                isLocalVar={this.props.isLocalVar}/>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}